import { Component, Prop, h } from '@stencil/core';

export enum BackgroundColor {
  none = 'none',
  emphasis = 'emphasis',
}

@Component({
  tag: 'amp-content-text-section',
  styleUrls: ['../../base.css'],
  shadow: true,
})
export class AmpContentTextSection {
  /**
   * Heading text for the section
   */
  @Prop() heading: string;
  /**
   * The background color of the section
   */
  @Prop() backgroundColor: BackgroundColor;

  render() {
    const heading = this.heading;
    const backgroundColor = this.backgroundColor || BackgroundColor.none;

    return (
      <div class={`amp-component flex flex-col gap-4 bg-${backgroundColor} ${backgroundColor === BackgroundColor.emphasis && 'p-4 md:p-8'}`}>
        {heading && <h2 class="font-semibold text-xl">{heading}</h2>}
        <div class="flex flex-col gap-8">
          <slot></slot>
        </div>
      </div>
    );
  }
}
